import CaseTaskBadgeForCaseStatus from "@/components/Table/MrtCaseFilters/CaseTaskBadgeForCaseStatus.tsx";
import NotificationBadgeForCaseStatus from "@/components/Table/MrtCaseFilters/NotificationBadgeForCaseStatus.tsx";
import TabBadges from "@/components/Table/MrtCaseFilters/TabBadges.tsx";
import { Button, ButtonGroup } from "@mui/material";

type Props = {
    selectedTab: string;
    setSelectedTab: (selectedTab: string) => void;
};

const CaseManagerFilters = ({ selectedTab, setSelectedTab }: Props) => {
    return (
        <ButtonGroup aria-label="Basic button group" fullWidth sx={{ mb: 2 }}>
            <Button
                onClick={() => setSelectedTab("")}
                variant={selectedTab === "" ? "contained" : "outlined"}
            >
                All Cases
                <TabBadges />
            </Button>
            <Button
                onClick={() => setSelectedTab("New Client")}
                variant={selectedTab === "New Client" ? "contained" : "outlined"}
            >
                New Client
                <NotificationBadgeForCaseStatus caseStatus="New Client" />
                <CaseTaskBadgeForCaseStatus caseStatus="New Client" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Treating")}
                variant={selectedTab === "Treating" ? "contained" : "outlined"}
            >
                Treating
                <NotificationBadgeForCaseStatus caseStatus="Treating" />
                <CaseTaskBadgeForCaseStatus caseStatus="Treating" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Done Treating")}
                variant={selectedTab === "Done Treating" ? "contained" : "outlined"}
            >
                Done Treating
                <NotificationBadgeForCaseStatus caseStatus="Done Treating" />
                <CaseTaskBadgeForCaseStatus caseStatus="Done Treating" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Demand Ready")}
                variant={selectedTab === "Demand Ready" ? "contained" : "outlined"}
            >
                Demand Ready
                <NotificationBadgeForCaseStatus caseStatus="Demand Ready" />
                <CaseTaskBadgeForCaseStatus caseStatus="Demand Ready" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Demand Complete")}
                variant={selectedTab === "Demand Complete" ? "contained" : "outlined"}
            >
                Demand Complete
                <NotificationBadgeForCaseStatus caseStatus="Demand Complete" />
                <CaseTaskBadgeForCaseStatus caseStatus="Demand Complete" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Withdrawal Pending")}
                variant={selectedTab === "Withdrawal Pending" ? "contained" : "outlined"}
            >
                Withdrawal Pending
                <NotificationBadgeForCaseStatus caseStatus="Withdrawal Pending" />
                <CaseTaskBadgeForCaseStatus caseStatus="Withdrawal Pending" />
            </Button>
        </ButtonGroup>
    );
};

export default CaseManagerFilters;
